import { ServiceLocator } from '@app/engine/core/service-locator';
import { WebWorkerThreadManager } from '@app/engine/threads/web-worker-thread';
import { OrbitCruncherMsgType } from '@app/webworker/orbit-cruncher-interfaces';
export class OrbitCruncherThreadManager extends WebWorkerThreadManager {
    WEB_WORKER_CODE = 'js/orbitCruncher.js';
    onMessage(m) {
        const { data } = m;
        if (!data) {
            return;
        }
        switch (data.type) {
            case OrbitCruncherMsgType.RESPONSE_READY:
                this.handleResponseReady_();
                break;
            case OrbitCruncherMsgType.RESPONSE_DATA:
                this.handleResponseData_(data);
                break;
            default:
                throw new Error('Unknown message type from Orbit Cruncher Worker');
        }
    }
    postMessage(message) {
        if (this.worker_) {
            this.worker_.postMessage(message);
        }
    }
    handleResponseReady_() {
        this.isReady_ = true;
    }
    handleResponseData_(data) {
        const satId = data.satId;
        const cachedOrbitData = ServiceLocator.getOrbitManager().orbitCache.get(satId);
        let pointsOut;
        if (!cachedOrbitData) {
            pointsOut = new Float32Array(data.pointsOut);
            ServiceLocator.getOrbitManager().orbitCache.set(satId, pointsOut);
        }
        else {
            cachedOrbitData.set(data.pointsOut);
            pointsOut = cachedOrbitData;
        }
        const gl = ServiceLocator.getRenderer().gl;
        gl.bindBuffer(gl.ARRAY_BUFFER, ServiceLocator.getOrbitManager().glBuffers_[satId]);
        gl.bufferData(gl.ARRAY_BUFFER, pointsOut, gl.DYNAMIC_DRAW);
        ServiceLocator.getOrbitManager().inProgress_[satId] = false;
    }
}
